import React from 'react';
import { useStyleConfig, vui } from '../core';
import List from '../list';
import { PopoverContent } from '../popover';
import { cs } from '../utils';
import { useMenuContext } from './context';
/** Displays a list of menu items in a popover content element. */
export const MenuList = vui((props, ref) => {
    const { className, contentProps, contentRef, ...rest } = props;
    const styles = useStyleConfig('Menu', useMenuContext());
    return (React.createElement(PopoverContent, { borderRadius: 0, ref: contentRef, ...contentProps },
        React.createElement(List, { className: cs('vui-menuList', className), py: 1, ref: ref, w: "100%", ...styles.list, ...rest })));
});
MenuList.Divider = List.Divider;
MenuList.Heading = List.Heading;
MenuList.Icon = List.Icon;
MenuList.Item = List.Item;
MenuList.Text = List.Text;
export default MenuList;
